import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ConfirmProvider } from 'material-ui-confirm';
import './App.css';
import Router from './router/routes';
import { useEffect } from 'react';
import { getUser } from './services/authService';
import { LocalStorageKey } from './constants/localStorageKeys';
import { useLocation } from 'react-router';
import { DictionaryService } from './services/dictionaryService';
import { RegionTypes } from './constants/regionType';
import { GTMCodes } from './helpers/getGTMCodeHelper';

function App() {
	const pathName = useLocation();
	const dictionaryService = new DictionaryService();
	localStorage.setItem(LocalStorageKey.loadAllCollection, '1');
	if (!localStorage.getItem('region')) {
		localStorage.setItem('region', RegionTypes.Global);
	}

	const theme = createTheme({
		palette: {
			primary: {
				main: '#33CD87',
			},
			secondary: {
				main: '#7850F2',
			},
		},
	});

	useEffect(() => {
		const handleChunkLoadError = (event) => {
			if (event?.reason && event?.reason?.message && event?.reason?.message?.includes('Loading chunk')) {
				console.error('Chunk loading failed:', event.reason);
				window.location.reload(true);
			}
		};

		window.addEventListener('unhandledrejection', handleChunkLoadError);

		return () => {
			window.removeEventListener('unhandledrejection', handleChunkLoadError);
		};
	}, []);

	useEffect(() => {
		if (
			getUser() &&
			localStorage.getItem(LocalStorageKey.loadAllCollection) === '1'
		) {
			getInvestorCollection();
			getBorrowerCollection();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathName]);

	const getInvestorCollection = () => {
		if (!dictionaryService.getInvestorCollectionLocally()) {
			dictionaryService
				.getAllInvestorCollections()
				.then((resp) => {
					localStorage.setItem(LocalStorageKey.loadAllCollection, '0');
					localStorage.setItem(
						LocalStorageKey.investorsCollections,
						JSON.stringify(resp.data)
					);
				})
				.catch((err) => { });
		}
	};

	const getBorrowerCollection = () => {
		if (!dictionaryService.getBorrowerCollectionLocally()) {
			dictionaryService
				.getAllBorrowerCollections()
				.then((resp) => {
					localStorage.setItem(LocalStorageKey.loadAllCollection, '0');
					localStorage.setItem(
						LocalStorageKey.borrowersCollections,
						JSON.stringify(resp.data)
					);
				})
				.catch((err) => { });
		}
	};

	const isProd = () => process.env.REACT_APP_ENV === 'prod';

	const addGTMAndSegment = () => {
		if (isProd()) {

			// GTM Script
			const gtmScript = document.createElement('script');
			gtmScript.innerHTML = GTMCodes().gtmScript;
			document.head.appendChild(gtmScript);

			// GTM Noscript
			const gtmNoscript = document.createElement('div');
			gtmNoscript.innerHTML = GTMCodes().gtmNoscript;
			document.body.appendChild(gtmNoscript);
		}
	};

	addGTMAndSegment();

	return (
		<ThemeProvider theme={theme}>
			<ConfirmProvider>
				<main className="App">
					<div id="alert-container"></div>
					<Router></Router>
				</main>
			</ConfirmProvider>
		</ThemeProvider>
	);
}

export default App;
